import FlipImageControl from "./FlipImageControl";

export default FlipImageControl;
